import ContentRating from '@/docs-partials/optional-settings/content-rating.mdx';
import * as React from 'react';
export default {
  ContentRating,
  React
};